import { NavigationBehaviorOptions } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { PageName } from 'src/app/core/enums';
import { PopupMessageService } from 'src/app/core/services/popup-message.service';
import { ForgotPasswordService } from './../services/forgot-password.service';
import { QueueService } from 'src/app/queue/queue/queue.service';
import { ThemeService } from 'src/app/shared/services/theme.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
})
export class ForgotPasswordComponent implements OnInit {
  pageName = PageName.ForgotPasswordPage;
  mobileNo: string;
  otpCode: string;
  isQueue: boolean;

  constructor(
    private forgotPasswordService: ForgotPasswordService,
    private popupMessageService: PopupMessageService,
    private queueService: QueueService,
    private themeService: ThemeService,
  ) { }

  async ngOnInit(): Promise<void> {
    this.themeService.checkHrefToGetChannelTag();
    let queueData = this.queueService.getQueueData();
    this.isQueue = queueData ? true : false;
    this.mobileNo = history.state?.data?.mobileNo ?? "";
    this.otpCode = history.state?.data?.otpCode ?? "";
  }

  async onFormSubmit(dt: any) {
    let resp: any = await this.forgotPasswordService.onForgotPassword(this.mobileNo, dt, this.otpCode);

    let navigationSetting: NavigationBehaviorOptions = {} as NavigationBehaviorOptions;
    navigationSetting.replaceUrl = true;

    let redirectRoute = 'login';
    if (this.isQueue) {
      redirectRoute = await this.queueService.getPreQueueRoute();
    }

    if (resp instanceof (HttpErrorResponse)) {
      this.popupMessageService.show({
        icon: "icon-alert",
        title: "failed.to.reset",
        desc: "error.failed.to.reset",
        btn: "button.okay",
        redirectLink: redirectRoute,
      });
    } else {
      this.popupMessageService.show({
        icon: "icon-lock",
        title: "success.to.reset",
        desc: "success.to.reset.desc",
        btn: "button.okay",
        redirectLink: redirectRoute,
      });
    }
  }
}
